import styled from "styled-components";
import {
  Card as AntCard,
  Typography,
  List,
  Modal as AntModal,
  Row,
  Tabs as AntTabs,
} from "antd";
import Colors from "../../../../themes/Colors";

const { Title, Text } = Typography;

export const CheckoutWrapper = styled.div`
  background-color: ${Colors.snow};
  border-radius: 8px;
  overflow: hidden;

  .checkoutInner {
    padding: 24px;
  }
  .checkoutContent {
    padding: 0 20px 32px 20px;
  }

  @media (max-width: 767px) {
    .checkoutInner {
      padding: 12px;
    }
    .checkoutContent {
      padding: 0 4px 24px 4px;
    }
  }
`;

export const StyledTabs = styled(AntTabs)`
  .ant-tabs-nav-wrap {
    background-color: ${Colors.background};
  }

  .ant-tabs-nav {
    margin: 0;
  }

  .ant-tabs-tab {
    background-color: ${Colors.background};
    border: 1px solid ${Colors.border};
    border-bottom: none;
    margin-right: 2px;
  }

  .ant-tabs-tab:not(.ant-tabs-tab-active) {
    .ant-tabs-tab-btn {
      color: ${Colors.textSecondary};
    }
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    background-color: ${Colors.snow};
    border-color: ${Colors.border};
    z-index: 2;

    .ant-tabs-tab-btn {
      color: var(--primaryAccent);
      font-weight: 500;
    }
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }

  .ant-tabs-content-holder {
    padding: 24px;
    border-top: 1px solid ${Colors.border};
    z-index: 1;
  }
`;

export const HeaderTitle = styled(Title)`
  &.ant-typography {
    margin: 0;
    font-size: 38px;
    line-height: 46px;
    font-weight: 500;
    color: ${Colors.textStrong};
    overflow-wrap: anywhere;

    @media (max-width: 767px) {
      font-size: 28px;
      line-height: 36px;
    }
  }
`;

export const HeaderSubtitle = styled(Text)`
  font-size: 16px;
  color: ${Colors.textMuted};
  line-height: 24px;
`;

export const SectionTitle = styled(Text)`
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${Colors.textStrong};
  margin-bottom: 12px;
`;

export const MetricCardContainer = styled.div`
  border: 1px solid ${Colors.border};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-width: 0;

  @media (max-width: 767px) {
    padding: 12px;
    gap: 10px;
  }
`;

export const MetricValue = styled(Text)`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: ${Colors.textStrong};
  overflow-wrap: anywhere;
`;

/* Caja de Subtotal / Presupuesto total. Sin alto fijo y con wrap para que en
   mobile las dos métricas se apilen en vez de desbordar. */
export const HighlightBox = styled(Row)`
  border: 1px solid var(--primary);
  border-radius: 12px;
  padding: 16px;
  margin: 0 !important;
  margin-bottom: 20px !important;
  min-height: 88px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 12px;
  ${MetricCardContainer} {
    border: none;
    padding: 0;
    height: auto;
    align-items: flex-start;
    gap: 16px;
  }
  ${MetricValue} {
    font-size: 20px;
    line-height: 28px;
  }
  .ant-col:nth-child(2) {
    ${MetricValue} {
      font-weight: 700;
    }
  }
  @media (max-width: 767px) {
    padding: 12px;
    ${MetricValue} {
      font-size: 18px;
      line-height: 26px;
    }
  }
`;

export const MetricIconWrapper = styled.div`
  font-size: 20px;
  color: var(--primaryAccent);
`;

export const MetricContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const MetricLabel = styled(Text)`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.textStrong};

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const MapPlaceholder = styled.div`
  width: 100%;
  height: 344px;
  background-color: ${Colors.gray};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;

export const MapSectionCard = styled(AntCard)`
  border: none;
  .ant-card-body {
    padding: 0;
  }
`;

export const SectionCard = styled(AntCard)`
  border: none;
`;

export const ScreenListCard = styled.div`
  border: 1px solid #ebebeb;
  border-radius: 12px;
  overflow: hidden;
`;

export const ScreenList = styled(List)`
  max-height: 344px;
  overflow-y: auto;
  padding: 16px;
  border: 1px solid ${Colors.border};
  border-radius: 12px;

  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: ${Colors.snow};
  }

  &::-webkit-scrollbar-thumb {
    background: ${Colors.gray};
    border-radius: 6px;
  }

  scrollbar-width: thin;
  scrollbar-color: #dce5e6;

  .ant-list-item {
    padding: 16px 0;
    border-bottom: 1px solid ${Colors.border};

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const ScreenListItem = styled(List.Item)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ScreenInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 160px;
`;

const TextBase = styled(Text)`
  display: block;
`;

export const ScreenName = styled(TextBase)`
  font-weight: 500;
  font-size: 15px;
  color: ${Colors.textStrong};
`;

export const ScreenType = styled(TextBase)`
  font-size: 13px;
  color: ${Colors.textMuted};
`;

export const ScreenPrice = styled(Text)`
  font-weight: 600;
  font-size: 15px;
  color: ${Colors.textStrong};
  white-space: nowrap;
`;

export const SpotButton = styled.button`
  background-color: ${Colors.snow};
  border: 1px solid ${Colors.borderStrong};
  border-radius: 6px;
  padding: 4px 12px;
  margin: 0 16px 0 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${Colors.textSecondary};
`;

export const HighlightCardWrapper = styled(SectionCard)`
  background-color: var(--primary);
  color: ${Colors.onPrimary};
  border: none;
  border-radius: 12px;
  height: 100%;

  .ant-card-body {
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media (max-width: 767px) {
    .ant-card-body {
      padding: 12px;
    }
  }
`;

export const HighlightValue = styled(Title)`
  &.ant-typography {
    color: ${Colors.white};
    font-size: 30px;
    font-weight: 700;
    margin: 4px 0 0 0;
    line-height: 40px;
    overflow-wrap: anywhere;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

export const HighlightLabel = styled(Text)`
  color: ${Colors.white};
  line-height: 24px;
  font-size: 16px;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: 250px;
`;

export const ChartTitle = styled(Title)`
  &.ant-typography {
    font-size: 16px !important;
    margin-bottom: 0 !important;
  }
`;

export const SpotIconWrapper = styled.span`
  cursor: pointer;
  color: var(--primaryAccent);
  margin-left: 16px;
  font-size: 16px;

  &:hover {
    opacity: 0.7;
  }
`;

export const StyledModal = styled(AntModal)`
  .ant-modal-content {
    border-radius: 8px;
  }
  .ant-modal-header {
    padding: 16px;
    border: none;
  }
  .ant-modal-body {
    padding: 24px;
    padding-top: 0;
  }
  .ant-modal-footer {
    border-top: none;
    padding: 0 24px 24px;
  }

  /* Hacemos el modal más ancho */
  @media (min-width: 768px) {
    width: 600px !important;
  }
`;

export const ModalResumeText = styled(Text)`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: var(--primaryAccent);
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
`;

export const ModalInfoLabel = styled(Text)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.textStrong};
`;

export const ModalInfoValue = styled(Text)`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.textStrong};
`;

export const ModalInfoRow = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 12px;
  font-size: 16px;
  gap: 8px;
`;

export const ModalImagePlaceholder = styled.div`
  width: 100%;
  height: 250px;
  background-color: #001529;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.white};
  font-size: 24px;
  margin-top: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
  }
`;
